import { Button } from '@mantine/core';
import { IconArrowLeft } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { Outlet, useNavigate } from 'react-router-dom';

import { InventoryItemTable } from 'src/Components/Inventory/InventoryItemTable';
import { PageHeader } from 'src/Components/Navigation/PageHeader';
import { useFetchInventoryExited } from 'src/Hooks/Queries/useFetchInventory';
import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';

import styles from './InventoryExitedPage.module.scss';

/** Broken, given, sold… objects: out of the totals and the insurer file, never lost. */
const InventoryExitedPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const assetId = useCurrentAssetId();
  const { data: items, isLoading, isError } = useFetchInventoryExited();

  return (
    <div className={styles.container}>
      <PageHeader
        label={t('inventory.exited.title', 'Objets sortis')}
        rightElement={
          <Button
            variant="outline"
            leftSection={<IconArrowLeft size={20} />}
            onClick={() => navigate(`/asset/${assetId}/inventories`)}
          >
            {t('inventory.back', "Retour à l'inventaire")}
          </Button>
        }
      />
      <div className={styles.subtitle}>
        {t(
          'inventory.exited.text',
          'Ils ne comptent plus dans l’inventaire ni dans le dossier pour l’assurance. Leurs photos, factures et souvenirs restent.'
        )}
      </div>
      <div className={styles.cardContainer}>
        <InventoryItemTable
          items={items}
          fetching={isLoading}
          exited
          noRecordsText={
            isError
              ? t('inventory.error', "Impossible d'afficher l'inventaire.")
              : t('inventory.exited.empty', 'Aucun objet sorti.')
          }
          onItemClick={item => navigate(item.id)}
        />
      </div>
      <Outlet />
    </div>
  );
};

export default InventoryExitedPage;
